import {
  Box,
  Button,
  Divider,
  Flex,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { navigate } from '@reach/router';
import { Auth } from 'aws-amplify';
import React, { useRef, useState } from 'react';
import { ImUser } from 'react-icons/im';
import { IoMdUnlock } from 'react-icons/io';
import { MdSettings } from 'react-icons/md';
import { RiLogoutBoxRFill } from 'react-icons/ri';
import { connect } from 'react-redux';
import { logout } from '../../../utils/auth';
import { menuListStylesProps } from '../../../utils/stylesProps';
import ChangePasswordView from '../../auth/change-password';
import ConfirmationView from '../confirmation-view';
import MobileSidebar from '../mobile-sidebar';

function TopbarWithoutRedux({ pageName, user, profileImage }) {
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const changePasswordConfirmOpenFunc = (bool) => {
    setChangePasswordOpen(bool);
  };

  const onChangePasswordClose = () => {
    setChangePasswordOpen(false);
  };

  const cancelRef = useRef();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const signout = async () => {
    await Auth.signOut();
    logout(() => {
      navigate('/login');
    });
  };
  const onConfirmClose = () => {
    setConfirmOpen(false);
  };

  return (
    <>
      <ConfirmationView
        onConfirmClose={onConfirmClose}
        message="Are you sure you want to Signout"
        callbackFunction={signout}
        isOpen={confirmOpen}
        setIsOpen={setConfirmOpen}
        cancelRef={cancelRef}
        submitBtnText="Signout"
      />
      <Box>
        <Flex minH="60px" align="center">
          <MobileSidebar />

          <Flex flex={{ base: 1 }} justify={{ base: 'center', md: 'start' }}>
            <Button
              width="170px"
              variant="link"
              onClick={() => {
                navigate('/');
              }}
            >
              <Image src={require('../../../assets/logo/small.svg')} />
            </Button>

            <Flex
              ml={10}
              color="brand.green"
              fontWeight="700"
              fontSize="md"
              textTransform="uppercase"
              alignItems="center"
            >
              <Divider
                display={{ base: 'none', md: 'flex' }}
                orientation="vertical"
                width="3px"
                borderColor="#717476"
                mr={4}
              />
              <Text alignSelf="center" display={{ base: 'none', md: 'flex' }}>
                {pageName}
              </Text>
            </Flex>
          </Flex>
          <Stack
            pr="2"
            flex={{ base: 1, md: 0 }}
            justify="flex-end"
            direction="row"
            spacing={4}
          >
            <Flex
              direction="column"
              alignItems="center"
              justifyContent="center"
              display={{ base: 'none', md: 'flex' }}
            >
              <Text noOfLines={1} isTruncated title={user?.firstName}>
                {user?.firstName} {user?.middleName} {user?.lastName}
              </Text>
              <Text
                noOfLines={1}
                fontSize="13px"
                isTruncated
                title={user?.firstName}
              >
                {user?.channelType
                  ? `${user?.channelType} | ${user?.userRole}`
                  : user?.userRole}
                {/* {user?.channelType} | {user?.userRole} */}
              </Text>
            </Flex>
            <Menu>
              <MenuButton
                as={Button}
                rounded="full"
                variant="link"
                cursor="pointer"
                width="50px"
                height="50px"
              >
                <Image
                  borderRadius="full"
                  height="38px"
                  src={
                    profileImage || require('../../../assets/defaultUser.png')
                  }
                />
              </MenuButton>
              <MenuList {...menuListStylesProps} w="200px">
                <MenuItem
                  _hover={{ bg: 'brand.red' }}
                  _focus={{ bg: 'brand.red' }}
                  onClick={() => {
                    navigate('/userprofile/');
                  }}
                  icon={<ImUser fontSize="18px" />}
                >
                  My Profile
                </MenuItem>
                <MenuItem
                  _hover={{ bg: 'brand.red' }}
                  _focus={{ bg: 'brand.red' }}
                  onClick={() => {
                    changePasswordConfirmOpenFunc(true);
                    // navigate('/changePassword/');
                  }}
                  icon={<IoMdUnlock fontSize="18px" />}
                >
                  Change Password
                </MenuItem>
                {/* <MenuItem
                  _hover={{ bg: 'brand.red' }}
                  icon={<MdSettings fontSize="18px" />}
                >
                  Settings
                </MenuItem> */}
                <MenuItem
                  icon={<RiLogoutBoxRFill fontSize="18px" />}
                  _hover={{ bg: 'brand.red' }}
                  onClick={() => {
                    setConfirmOpen(true);
                  }}
                >
                  Sign out
                </MenuItem>
              </MenuList>
            </Menu>
          </Stack>
        </Flex>
        <ChangePasswordView
          onChangePasswordClose={onChangePasswordClose}
          isOpen={changePasswordOpen}
        />
      </Box>
    </>
  );
}

const stateMapper = (state) => ({
  pageName: state.page.currentPageTitle,
  profileImage: state.auth.profileImage,
  user: state.auth?.user,
});

const dispatchMapper = (dispatch) => ({});
export default connect(stateMapper, dispatchMapper)(TopbarWithoutRedux);
